(() => {
  function initialize(root = document) {
    root.querySelectorAll('[data-st-review-more]').forEach(button => {
      if (button.dataset.ready) return;
      button.dataset.ready = 'true';
      const text = button.closest('article').querySelector('[data-st-review-text]');
      text.classList.add('is-clamped');
      button.hidden = false;
      button.addEventListener('click', () => {
        const expanded = button.getAttribute('aria-expanded') !== 'true';
        button.setAttribute('aria-expanded', String(expanded));
        button.textContent = expanded ? 'Read less' : 'Read more';
        text.classList.toggle('is-clamped', !expanded);
      });
    });
    root.querySelectorAll('[data-st-purchase]').forEach(form => {
      if (form.dataset.ready) return;
      form.dataset.ready = 'true';
      const variant = form.querySelector('[data-st-variant]');
      const message = form.querySelector('.st-purchase-status');
      const buttons = [...form.querySelectorAll('button[type="submit"]')];
      const updateVariant = () => {
        form.querySelectorAll('[data-st-attribute]').forEach(input => input.remove());
        const option = variant?.selectedOptions[0];
        if (option?.dataset.attributes) {
          Object.entries(JSON.parse(option.dataset.attributes)).forEach(([name, value]) => {
            const input = document.createElement('input');
            input.type = 'hidden'; input.name = name; input.value = value;
            input.dataset.stAttribute = 'true'; form.append(input);
          });
        }
        if (option?.dataset.price) form.closest('.st-product').querySelector('[data-st-price]').textContent = option.dataset.price;
        message.textContent = '';
      };
      variant?.addEventListener('change', updateVariant);
      updateVariant();
      form.addEventListener('submit', async event => {
        const intent = event.submitter?.dataset.intent || 'cart';
        if (form.dataset.stPurchase === 'external') {
          updateVariant();
          // Standard WooCommerce GET submission preserves the existing store cart
          // across this top-level navigation, including colour/set attributes.
          form.setAttribute('aria-busy', 'true');
          message.textContent = intent === 'buy' ? 'Taking you to checkout…' : 'Opening your toy bag…';
          return;
        }
        event.preventDefault();
        if (form.getAttribute('aria-busy') === 'true') return;
        form.setAttribute('aria-busy', 'true');
        buttons.forEach(button => { button.disabled = true; });
        message.textContent = 'Making room for a little happy…';
        try {
          const response = await fetch(form.action.replace(/\/$/, '') + '.js', {
            method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items: [{ id: Number(new FormData(form).get('id')), quantity: 1 }] })
          });
          const result = await response.json();
          if (!response.ok) throw new Error(result.description || result.message || 'This toy could not be added. Please try again.');
          if (intent === 'buy') { window.location.assign(form.dataset.checkoutUrl); return; }
          if (window.SashaktCart) await window.SashaktCart.open(event.submitter);
          message.textContent = 'A little happy, added! ';
          const cartLink = document.createElement('a');
          cartLink.href = form.dataset.cartUrl; cartLink.textContent = 'View your bag →'; message.append(cartLink);
          document.querySelectorAll('.st-header-actions a[aria-label="Shopping bag"]').forEach(link => { link.href = form.dataset.cartUrl; });
          form.classList.add('is-added');
          setTimeout(() => form.classList.remove('is-added'), 1400);
        } catch (error) {
          message.textContent = error.message || 'Please try again.';
        } finally {
          form.removeAttribute('aria-busy');
          buttons.forEach(button => { button.disabled = false; });
        }
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize());
  else initialize();
  document.addEventListener('shopify:section:load', event => initialize(event.target));
  window.addEventListener('pageshow', () => document.querySelectorAll('[data-st-purchase][aria-busy]').forEach(form => form.removeAttribute('aria-busy')));
})();
